import type { ReactNode } from 'react';

const replaceString = (text: string, search: RegExp, replace: ReactNode) =>
    text.split(search).flatMap((item, index) => {
        if (index !== 0) {
            return [replace, item];
        }

        return item;
    });

const replaceStringWithElement = (
    input: string | readonly ReactNode[],
    search: RegExp,
    replace: ReactNode,
): readonly ReactNode[] => {
    if (typeof input === 'string') {
        return replaceString(input, search, replace);
    }

    return input.flatMap((item) => {
        if (typeof item === 'string') {
            return replaceString(item, search, replace);
        }

        return item;
    });
};

export default replaceStringWithElement;
